export const LAYOUT = {
  NAV_WIDTH: 280,
  APPBAR_HEIGHT: 72,
  CONTENT_PADDING: { xs: 2, sm: 3, lg: 4 },
  PAGE_SPACING: { mt: 4, mb: 4 },
};

export const CHART_COLORS = [
  '#2196F3',
  '#4CAF50',
  '#FF9800',
  '#E91E63',
  '#9C27B0',
  '#00BCD4',
  '#FF5722',
  '#3F51B5',
  '#8BC34A',
  '#FFC107',
  '#607D8B',
  '#795548',
  '#009688',
  '#673AB7',
  '#CDDC39',
  '#F44336',
];
